<template>
  <div class="shop-add">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="110px">
      <div class="title">店铺信息</div>
      <el-form-item label="商场" prop="mallId">
        <el-select v-model="form.mallId" placeholder="请选择商场" @change="onMallChange" :disabled="!!$route.query.id">
          <el-option v-for="item in mallData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="店铺名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入店铺名称" class="input" />
      </el-form-item>
      <el-form-item label="店铺LOGO" prop="logo">
        <UploadImg @getUploadFile="getUploadFile" :uploadUrl="form.logo"></UploadImg>
      </el-form-item>
      <el-form-item label="所属业态" prop="category">
        <el-cascader
          v-model="form.category"
          placeholder="请选择所属业态"
          :options="shopCategoryData"
          :props="categoryCascaderProps"
          clearable
        >
        </el-cascader>
      </el-form-item>
      <el-form-item label="所在楼层" prop="floor">
        <el-select v-model="form.floor" placeholder="请选择所在楼层">
          <el-option v-for="item in shopFloorData" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="店铺状态" prop="disable">
        <el-radio-group v-model="form.disable">
          <el-radio :label="false">开启</el-radio>
          <el-radio :label="true">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-divider />

      <div class="title">
        <span>其他信息</span>
        <span class="title-remark">（选填）</span>
      </div>
      <el-form-item label="店铺编号" prop="refId">
        <el-input v-model="form.refId" placeholder="请输入店铺编号" :disabled="!!$route.query.id" />
      </el-form-item>
      <el-form-item label="店铺简介" prop="introduction">
        <el-input type="textarea" rows="6" v-model="form.introduction" placeholder="请输入店铺简介" maxlength="100" show-word-limit />
      </el-form-item>
      <el-form-item label="联系人姓名" prop="contractor">
        <el-input v-model="form.contractor" placeholder="请输入联系人姓名" />
      </el-form-item>
      <el-form-item label="联系人手机号" prop="contractorPhone">
        <el-input v-model="form.contractorPhone" placeholder="请输入联系人手机号" maxLength="11" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" rows="6" v-model="form.remark" placeholder="请输入备注" maxlength="100" show-word-limit />
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="onBack" class="mr20">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg/index'
import { api_getShopDetail, api_postShopAdd, api_putShopEdit } from '@/api/shop'
import { api_getConfig, api_postFileUpload } from '@/api/common'
export default {
  name: "shopAdd",
  components: {
    UploadImg
  },
  data() {
    const checkPhone = (rule, value, callback) => {
      const check = /^1\d{10}$/
      if (value && !check.test(value)) {
        callback(new Error('手机号格式有误'))
      } else {
        callback()
      }
    }
    const checkLogo = (rule, value, callback) => {
      if (!this.form.logo) {
        callback(new Error('请上传店铺LOGO'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      form: {
        disable: false,
        logo: ''
      },
      rules: {
        mallId: [{ required: true, message: '请选择商场' }],
        name: [{ required: true, message: '请输入店铺名称' }],
        logo: [{ validator: checkLogo }],
        floor: [{ required: true, message: '请选择楼层' }],
        category: [{ required: true, message: '请选择所属业态' }],
        contractorPhone: [{validator: checkPhone, trigger: 'blur'}]
      },

      categoryCascaderProps: {
        // checkStrictly: true,
        value: "name",
        label: "name",
        // leaf: "pid"
      },
      mallData: [], // 商场下拉框数据
      shopCategoryData: [], // 所属业态数据
      shopFloorData: [], // 楼层数据
    };
  },
  created() {
    this.getConfigData() // 获取商场、业态数据

    if (this.$route.query.id) {
      this.$route.meta.title = '编辑店铺'
      this.id = this.$route.query.id
      this.getDetailDate() // 获取详情数据
    } else {
      this.$route.meta.title = '录入店铺'
    }
  },
  methods: {
    // 获取商场、业态数据
    async getConfigData() {
      const {mall, category} = await api_getConfig(['mall', 'category'])
      this.shopCategoryData = category
      this.mallData = mall
      if (this.mallData.length == 1) {
        this.form = {
          ...this.from,
          mallId: res[0].id
        }
      }
    },

    // 商场下拉框改变
    onMallChange(value) {
      this.getShopFloorData(value)
    },

    //获取楼层下拉框数据
    async getShopFloorData(mallId) {
      const curMall = this.mallData.filter(item => item.id == mallId)
      this.shopFloorData = curMall[0].floors || []
    },

    // 获取详情数据
    async getDetailDate() {
      const res = await api_getShopDetail({id: this.$route.query.id})
      console.log('res: ', res);
      this.onMallChange(res.mallId) // 获取该商场下的楼层数据
      this.form = {
        ...res,
        category: res.category ? res.category.split(',') : []
      }
    },
    getUploadFile (file) {
      this.form.logo = file
    },
    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let params = {
              ...this.form,
              category: this.form.category ? this.form.category.join(',') : '',
            }
            if (this.form.logo.size) {
              const { key } = await api_postFileUpload(this.form.logo, 'StoreLogo')
              params.logo = key
            }
            console.log('params: ', params);
            // return

            params.id ? await api_putShopEdit(params) : await api_postShopAdd(params)
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },

    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-add {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;

  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    .title-remark {
      color: #666666;
      font-size: 14px;
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 350px;
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
